import { useMutation } from '@tanstack/react-query';
import { cancelGroupBooking } from 'stores/queries/booking/booking-queries';

export function useMutationCancelGroupBooking() {
  return useMutation(cancelGroupBooking);
}
